<template>
  <v-container class="layout-container">
    <Feature feature-slug="new-landingpage-details">
      <template v-slot:default>
        <LandingpageDetails />
      </template>

      <template v-slot:disabled>
        <Landingpage />
      </template>
    </Feature>
  </v-container>
</template>

<script>
import feature from '@/mixins/feature'
import Landingpage from '@/modules/landingpage'
import LandingpageDetails from '@/modules/landingpage/LandingpageDetails.vue'

export default {
  mixins: [feature],
  components: {
    Landingpage,
    LandingpageDetails,
  },
}
</script>
